import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import { getAccessToken } from './services/api/authentication'
export default {
  install (Vue) {

    // Default to the production scanner hub.
    //var scannerHubUrl = "http://sf2019.xbyte.local/scanner-hub";
    var scannerHubUrl = "https://api.marketscout.xbyte.com/scanner-hub";
    // If we're running on localhost, then:
    if (window.location.hostname === "localhost") {
      // Use the corresponding localhost scannner hub.
      scannerHubUrl = "http://localhost:54381/scanner-hub";
    }

    const connection = new HubConnectionBuilder()
    // TODO:  Figure out how to dynamically set up the url rather than the above hard-coded version  
    // TODO: remove this commented section after verifying the scanner updates work on localhost and production.
      //.withUrl('http://localhost:54381/scanner-hub')
      //.withUrl('http://sf2019.xbyte.local/scanner-hub')
      .withUrl(scannerHubUrl, {
        accessTokenFactory: async () => {
          return await getAccessToken();
      }})
      
      //.withUrl('${Vue.prototype.$http.defaults.baseURL}/scanner-hub')
      .configureLogging(LogLevel.Information)
      .build();

    // use a new Vue instance as an event bus
    const scannerHub = new Vue();
    
    // every component will use this.$scannerHub to access the event bus
    Vue.prototype.$scannerHub = scannerHub;
    
    // Forward server side SignalR events through $scannerHub, where components will listen to them
    connection.on('StatusChanged', (scanProgress) => {
      scannerHub.$emit('status-changed', { scanProgress })
    }),
    
    connection.on('ScanCompleted', (newItemID) => {
      scannerHub.$emit('scan-completed', { newItemID })
    });


    let startedPromise = null;
    function start () {
        startedPromise = connection.start().catch(err => {
            console.error('Failed to connect with hub', err);
            return new Promise((resolve, reject) => 
            setTimeout(() => start().then(resolve).catch(reject), 5000));
        })
        return startedPromise;
    }
    
    connection.onclose(() => start());
        
    start();
  }
}